import capitalizeFirstLetter from '@/util/capitalizeFirstLetter';
import selectOptions from '@/util/selectOptions';
import { diffDates } from '@/util/datetime';

const GlobalHelpers = {
  install(Vue) {
    Vue.prototype.$capitalize = capitalizeFirstLetter;
    Vue.prototype.$selectOptions = selectOptions;
    Vue.prototype.$diffDates = diffDates;
  },
};

export default GlobalHelpers;
